import type { JSX, ReactNode } from 'react';
import Footer from '../components/Footer';
import { supportFormURL } from '../util/constants';
import { BrandLockup } from './BrandLockup';
import { MapGradientBackground } from './MapGradientBackground';

interface ErrorPageShellProps {
  readonly children: ReactNode;
  readonly secondaryText: string;
  readonly secondaryActionLabel: string;
  readonly additionalText?: string;
}

function openSupportForm(): void {
  if (supportFormURL) {
    window.open(supportFormURL, '_blank', 'noopener,noreferrer');
  }
}

/**
 * Full-page shell shared by every error/not-found screen — map-gradient background,
 * centered brand lockup + card column, "contact support" secondary line, footer.
 * Visual parity target: aosphere-nextgenui-user's /error and /page-not-found routes,
 * which use this exact composition (MapGradientBackground + AosBrandLockup + Footer).
 */
export function ErrorPageShell({
  children,
  secondaryText,
  secondaryActionLabel,
  additionalText = 'and quote the reference above.',
}: ErrorPageShellProps): JSX.Element {
  return (
    <div className="d-flex flex-column" style={{ position: 'relative', minHeight: '100vh' }}>
      <MapGradientBackground />
      <div className="d-flex flex-column flex-grow-1" style={{ position: 'relative', zIndex: 1 }}>
        <div
          className="d-flex flex-column flex-grow-1 align-items-center justify-content-center mx-auto py-5"
          style={{ width: 460, maxWidth: '92%', gap: 26 }}
        >
          <BrandLockup />
          {children}
          <p
            className="text-center mb-0"
            style={{ color: 'rgba(255,255,255,0.85)', fontSize: 13, marginTop: -10 }}
          >
            {secondaryText}
            <br />
            <button
              type="button"
              className="btn btn-link p-0"
              style={{ color: '#fff', textDecoration: 'underline', fontWeight: 600 }}
              onClick={openSupportForm}
            >
              {secondaryActionLabel}
            </button>{' '}
            {additionalText}
          </p>
        </div>
        <Footer variant="dark" />
      </div>
    </div>
  );
}
